export function changedFields<T extends Record<string, any>>(
  original: T,
  values: Partial<T>,
): Partial<T> {
  return Object.fromEntries(
    Object.entries(values)
      .filter(([key]) => !["id", "created_at", "updated_at"].includes(key))
      .map(([key, value]) => [key, value === undefined ? null : value])
      .filter(
        ([key, value]) =>
          JSON.stringify(value) !==
          JSON.stringify(original[key as string] ?? null),
      ),
  ) as Partial<T>;
}
